import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeProvider } from "./contexts/ThemeSelection";
import { UserProvider } from "./contexts/UserContext";
import { UserSettingsProvider } from "./contexts/UserSettingsContext";
import { CategoryProvider } from "./contexts/CategoryContext";
import { FeatureFlagProvider } from "./contexts/FeatureFlagContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { PregnancyProvider } from "./contexts/PregnancyContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ErrorBoundary from "./components/ErrorBoundary";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";

// Configure native platform (no-op on web)
if (Capacitor.isNativePlatform()) {
  StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
  StatusBar.setBackgroundColor({ color: "#000000" }).catch(() => {});
  SplashScreen.hide().catch(() => {});
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ErrorBoundary>
    <HashRouter>
      <UserProvider>
        <FeatureFlagProvider>
          <CategoryProvider>
            <ThemeProvider>
              <UserSettingsProvider>
                <NotificationProvider>
                  <PregnancyProvider>
                    <ScrollToTop />
                    <App />
                  </PregnancyProvider>
                </NotificationProvider>
              </UserSettingsProvider>
            </ThemeProvider>
          </CategoryProvider>
        </FeatureFlagProvider>
      </UserProvider>
    </HashRouter>
  </ErrorBoundary>
);

// Register service worker for PWA offline support (production only)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      // Listen for the new SW taking control, then reload
      let reloading = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading) return;
        reloading = true;
        globalThis.location.reload();
      });
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

// If a waiting service worker already exists from a prior session, activate it now.
// This handles the case where an update was found on a previous visit but the user
// never closed all tabs (common on mobile phones).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    if (registration.waiting) {
      let reloading = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloading) return;
        reloading = true;
        globalThis.location.reload();
      });
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  });
}
